import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadEvent } from '~/state/modules/events'
import { Typography } from '@material-ui/core'
import { createSector, createSeats } from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { SectorForm } from '../SectorForm'
import { ROUTES } from '~/views/routes'
import { PositionDescriptor, SEATS_STATUS, SeatStatus } from 'config/constants'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'

export const SectorCreatePage = ({ match, onSuccess }) => {
  const { pendingCreateLayout, pendingCreateSeats } = useSelector(
    (state) => state.planimetry
  )
  const { eventId, layoutId } = match.params
  const { event } = useSelector((state) => state.events)

  const dispatch = useDispatch()

  const initializeSeats = (numRows, numColumns) => {
    const newSeats = Array.from({ length: numRows * numColumns }, (_, idx) => ({
      row: Math.floor(idx / numColumns) + 1,
      column: (idx % numColumns) + 1,
      status: SeatStatus.Available
    }))
    return newSeats
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      const sector = await dispatch(createSector(values))
      const payload = {
        SectorId: sector.Id,
        Column: values.Column,
        Row: values.Row,
        Seats: initializeSeats(values.Row, values.Column).map((seat) => ({
          Column: seat.column,
          Row: seat.row,
          IsSeat: true,
          Status: SEATS_STATUS[seat.status],
          Id: seat.id
        }))
      }
      await dispatch(createSeats(payload))
      onSuccess(eventId, layoutId)
      showSnackbarSuccess('Sector Creado!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    SectorName: '',
    Column: '',
    ColumnDescriptor: PositionDescriptor.Numeric,
    Row: '',
    RowDescriptor: PositionDescriptor.Numeric,
    ImageId: '',
    ImageFile: null,
    LayoutId: layoutId,
    Color: ''
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadEvent(eventId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {event && (
        <Typography variant='h6' style={{ paddingInline: 8, paddingBottom: 8 }}>
          {`${event?.Title} (${event?.Id})`}{' '}
        </Typography>
      )}
      <PaperContainer title='Creación de Sector'>
        <SectorForm
          values={values}
          actionText='Crear'
          handleSubmit={handleSubmit}
          actionPending={pendingCreateLayout || pendingCreateSeats}
          onCancel={() =>
            history.push(
              ROUTES.ADMIN.EVENTS.SECTORS.INDEX.replace(
                ':eventId',
                eventId
              ).replace(':layoutId', layoutId)
            )
          }
        />
      </PaperContainer>
    </>
  )
}

export default SectorCreatePage
